/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './text-field.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/material';
import * as i3 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i4 from '@angular/forms';
import * as i5 from '../../../../../../app/modules/fields/components/text-field/text-field.component';
import * as i6 from '@angular/cdk/platform';
import * as i7 from '@angular/common';
const styles_TextFieldComponent:any[] = [i0.styles];
export const RenderType_TextFieldComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TextFieldComponent,data:{}});
function View_TextFieldComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'md-hint',[['align',
      'start'],['class','mat-hint']],[[2,'mat-right',(null as any)],[1,'id',0],[1,
      'align',0]],(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(1,
      16384,(null as any),0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(2,16384,[[4,4]],0,i2.MdHint,
      ([] as any[]),{align:[0,'align']},(null as any)),(_l()(),i1.ɵted(3,(null as any),
      ['\n  ','\n  ','\n']))],(_ck,_v) => {
    const currVal_3:any = 'start';
    _ck(_v,2,0,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,2).align == 'end');
    const currVal_1:any = i1.ɵnov(_v,2).id;
    const currVal_2:any = (null as any);
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = (_co.fieldValue.field.required? '': '(Not Required)');
    const currVal_5:any = _co.fieldValue.field.hint;
    _ck(_v,3,0,currVal_4,currVal_5);
  });
}
export function View_TextFieldComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(1,0,
      (null as any),(null as any),25,'md-form-field',[['class','mat-input-container mat-form-field']],
      [[2,'completed',(null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-form-field-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)]],[[(null as any),'click'],[(null as any),'submit'],[(null as any),
          'reset']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,3)._control.focus()) !== false);
          ad = (pd_0 && ad);
        }
        if (('submit' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,10).onSubmit($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('reset' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,10).onReset()) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i3.View_MdFormField_0,i3.RenderType_MdFormField)),i1.ɵdid(2,16384,(null as any),
      0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(3,7389184,(null as any),6,i2.MdFormField,[i1.ElementRef,
      i1.ChangeDetectorRef,[2,i2.MD_PLACEHOLDER_GLOBAL_OPTIONS]],{floatPlaceholder:[0,
      'floatPlaceholder']},(null as any)),i1.ɵqud(335544320,1,{_control:0}),i1.ɵqud(335544320,
      2,{_placeholderChild:0}),i1.ɵqud(603979776,3,{_errorChildren:1}),i1.ɵqud(603979776,
      4,{_hintChildren:1}),i1.ɵqud(603979776,5,{_prefixChildren:1}),i1.ɵqud(603979776,
      6,{_suffixChildren:1}),i1.ɵdid(10,540672,(null as any),0,i4.FormGroupDirective,
      [[8,(null as any)],[8,(null as any)]],{form:[0,'form']},(null as any)),i1.ɵprd(2048,
      (null as any),i4.ControlContainer,(null as any),[i4.FormGroupDirective]),i1.ɵdid(12,
      16384,(null as any),0,i4.NgControlStatusGroup,[i4.ControlContainer],(null as any),
      (null as any)),(_l()(),i1.ɵted(-1,1,['\n  '])),(_l()(),i1.ɵeld(14,0,[['str',
      1]],1,8,'input',[['class','mat-input-element'],['mdInput','']],[[8,'id',0],[8,
      'placeholder',0],[8,'disabled',0],[8,'required',0],[1,'aria-describedby',0],
      [1,'aria-invalid',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
      [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
      [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
      'change'],[(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
      [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i5.TextFieldComponent = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,16)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,16).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,16)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i1.ɵnov(_v,16)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('blur' === en)) {
      const pd_4:any = ((<any>i1.ɵnov(_v,20)._focusChanged(false)) !== false);
      ad = (pd_4 && ad);
    }
    if (('focus' === en)) {
      const pd_5:any = ((<any>i1.ɵnov(_v,20)._focusChanged(true)) !== false);
      ad = (pd_5 && ad);
    }
    if (('input' === en)) {
      const pd_6:any = ((<any>i1.ɵnov(_v,20)._onInput()) !== false);
      ad = (pd_6 && ad);
    }
    if (('change' === en)) {
      const pd_7:any = ((<any>_co.handleChange(i1.ɵnov(_v,14).value)) !== false);
      ad = (pd_7 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(15,16384,(null as any),0,i2.MdPrefixRejector,
      [[2,i2.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16,16384,(null as any),0,i4.DefaultValueAccessor,[i1.Renderer2,i1.ElementRef,
          [2,i4.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),i1.ɵprd(1024,
          (null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i4.DefaultValueAccessor]),i1.ɵdid(18,671744,(null as any),0,i4.FormControlName,
          [[3,i4.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],
          {name:[0,'name']},(null as any)),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.FormControlName]),i1.ɵdid(20,933888,(null as any),0,i2.MdInput,
          [i1.ElementRef,i1.Renderer2,i6.Platform,[2,i4.NgControl],[2,i4.NgForm],[2,
              i4.FormGroupDirective],[2,i2.MD_ERROR_GLOBAL_OPTIONS]],(null as any),
          (null as any)),i1.ɵdid(21,16384,(null as any),0,i4.NgControlStatus,[i4.NgControl],
          (null as any),(null as any)),i1.ɵprd(2048,[[1,4]],i2.MdFormFieldControl,
          (null as any),[i2.MdInput]),(_l()(),i1.ɵted(-1,1,['\n  '])),(_l()(),i1.ɵand(16777216,
          (null as any),5,1,(null as any),View_TextFieldComponent_1)),i1.ɵdid(25,16384,
          (null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(-1,1,['\n'])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n\n\n']))],(_ck,_v) => {
    var _co:i5.TextFieldComponent = _v.component;
    const currVal_18:any = 'never';
    _ck(_v,3,0,currVal_18);
    const currVal_19:any = _co.form;
    _ck(_v,10,0,currVal_19);
    const currVal_33:any = _co.getKey();
    _ck(_v,18,0,currVal_33);
    _ck(_v,20,0);
    const currVal_34:any = _co.fieldValue.field.hint;
    _ck(_v,25,0,currVal_34);
  },(_ck,_v) => {
    var _co:i5.TextFieldComponent = _v.component;
    const currVal_0:any = _co.isValid();
    const currVal_1:any = i1.ɵnov(_v,3)._control.errorState;
    const currVal_2:any = i1.ɵnov(_v,3)._control.errorState;
    const currVal_3:any = i1.ɵnov(_v,3)._control.focused;
    const currVal_4:any = i1.ɵnov(_v,3)._shouldForward('untouched');
    const currVal_5:any = i1.ɵnov(_v,3)._shouldForward('touched');
    const currVal_6:any = i1.ɵnov(_v,3)._shouldForward('pristine');
    const currVal_7:any = i1.ɵnov(_v,3)._shouldForward('dirty');
    const currVal_8:any = i1.ɵnov(_v,3)._shouldForward('valid');
    const currVal_9:any = i1.ɵnov(_v,3)._shouldForward('invalid');
    const currVal_10:any = i1.ɵnov(_v,3)._shouldForward('pending');
    const currVal_11:any = i1.ɵnov(_v,12).ngClassUntouched;
    const currVal_12:any = i1.ɵnov(_v,12).ngClassTouched;
    const currVal_13:any = i1.ɵnov(_v,12).ngClassPristine;
    const currVal_14:any = i1.ɵnov(_v,12).ngClassDirty;
    const currVal_15:any = i1.ɵnov(_v,12).ngClassValid;
    const currVal_16:any = i1.ɵnov(_v,12).ngClassInvalid;
    const currVal_17:any = i1.ɵnov(_v,12).ngClassPending;
    _ck(_v,1,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
        currVal_14,currVal_15,currVal_16,currVal_17]);
    const currVal_20:any = i1.ɵnov(_v,20).id;
    const currVal_21:any = i1.ɵnov(_v,20).placeholder;
    const currVal_22:any = i1.ɵnov(_v,20).disabled;
    const currVal_23:any = i1.ɵnov(_v,20).required;
    const currVal_24:any = (i1.ɵnov(_v,20)._ariaDescribedby || (null as any));
    const currVal_25:any = i1.ɵnov(_v,20).errorState;
    const currVal_26:any = i1.ɵnov(_v,21).ngClassUntouched;
    const currVal_27:any = i1.ɵnov(_v,21).ngClassTouched;
    const currVal_28:any = i1.ɵnov(_v,21).ngClassPristine;
    const currVal_29:any = i1.ɵnov(_v,21).ngClassDirty;
    const currVal_30:any = i1.ɵnov(_v,21).ngClassValid;
    const currVal_31:any = i1.ɵnov(_v,21).ngClassInvalid;
    const currVal_32:any = i1.ɵnov(_v,21).ngClassPending;
    _ck(_v,14,1,[currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25,
        currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31,currVal_32]);
  });
}
export function View_TextFieldComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-text-field',
      ([] as any[]),[[2,'not-required',(null as any)]],(null as any),(null as any),
      View_TextFieldComponent_0,RenderType_TextFieldComponent)),i1.ɵdid(1,114688,(null as any),
      0,i5.TextFieldComponent,([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).isNotRequired;
    _ck(_v,0,0,currVal_0);
  });
}
export const TextFieldComponentNgFactory:i1.ComponentFactory<i5.TextFieldComponent> = i1.ɵccf('app-text-field',
    i5.TextFieldComponent,View_TextFieldComponent_Host_0,{editable:'editable',form:'form',
        fieldValue:'fieldValue'},{fieldValueChange:'fieldValueChange',edited:'edited'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/fields/components/text-field/text-field.component.ngfactory.ts